document.addEventListener('cart:updated', function(evt) {
  var subtotal = evt.detail.total;
  var freeShipping = 5000;
  var percent = subtotal / (freeShipping/100);
  var remaining = Math.round(freeShipping - subtotal);
  
  if (subtotal < freeShipping) {
    document.querySelector('.free_shipping').innerHTML = "<div>You're <span>"+ theme.Currency.formatMoney(remaining, theme.settings.moneyFormat) +"</span> from getting <strong>Free Shipping</strong>.</div><div class='pn-progressbar'><div class='pn-progressbar_ind' style='width:"+percent+"%'></div></div>";
  }else{
    document.querySelector('.free_shipping').innerHTML = "<div><strong>Yay!</strong> Free Shipping to US & Mexico.</div><div class='pn-progressbar'><div class='pn-progressbar_ind' style='width:100%'></div></div>";
  }
});